'use client'
import * as React from 'react'
import type { UseRefinementListProps } from 'react-instantsearch'
import { useMenu } from 'react-instantsearch'
import { Divider } from 'components/divider'
import { tw } from 'utils/classnames'
import { Checkbox } from 'primitives/cf-checkbox'

import { SearchableFilters } from '@web/components/content-api/search-page/utils'
import { useSearchPageContext } from '@web/components/algolia/providers/content-api-search-page-provider'
import { FilterAccordion } from './accordion'

export function PeopleSidebarFilter({
  header,
  withPeopleText,
  withoutPeopleText,
}: {
  header: string
  withPeopleText: string
  withoutPeopleText: string
}) {
  const { expanded } = useSearchPageContext()

  const transformWithPeople: UseRefinementListProps['transformItems'] = items => {
    return items
      .map(item => {
        return {
          ...item,
          label: item.value === 'true' ? withPeopleText : withoutPeopleText,
        }
      })
      .toSorted((a, b) => b.value.localeCompare(a.value))
  }

  const memoedTransformWithPeople = React.useCallback(transformWithPeople, [
    withPeopleText,
    withoutPeopleText,
  ])

  const { items, refine } = useMenu({
    attribute: 'flags.hasPeople',
    transformItems: memoedTransformWithPeople,
  })

  if (!items.length) {
    return null
  }

  const handleRefine = (value: string) => {
    refine(value)
  }

  const filterContent = (
    <div className="mt-5 flex flex-col">
      {items.map((item, index) => (
        <div key={item.label + index} className="wrap text-14 flex items-center">
          <Checkbox
            value={item.value}
            label={
              <>
                <span className={tw(item.isRefined && 'font-semibold', 'capitalize')}>
                  {item.label}
                </span>
                <span className="text-12 ml-[5px] text-[#A0B2B8]">({item.count})</span>
              </>
            }
            checked={item.isRefined}
            onClick={() => handleRefine(item.value)}
          />
        </div>
      ))}
    </div>
  )

  return (
    <>
      <FilterAccordion
        header={header}
        expanded={expanded ? expanded.includes(SearchableFilters.PEOPLE) : undefined}
      >
        <div className="flex flex-col gap-[10px]">{filterContent}</div>
      </FilterAccordion>
      <Divider className="relative left-[-20px] w-[calc(100%+40px)] bg-[#DFDDE5]" />
    </>
  )
}
